import { defineAction } from '~/prix'
import residenceImageListAction from './residenceImageList.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import expression from '~/prix/types/expression'

export const residenceImageObject = z.object({
  id: z.string().uuid(),
  residenceId: z.string().uuid(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  description: z.string().nullish(),
  position: z.number(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  status: enumerated({
    pending: 'Pendente',
    success: 'Sucesso',
    failed: 'Falhou',
  }),
})

export const residenceImageExpression = expression(residenceImageObject.shape)

const residenceImageListDefinition = defineAction({
  ...residenceImageListAction,

  input: z.object({
    filter: residenceImageExpression.nullish(),
    limit: z.number().min(1).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      description: 'Descrição',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({ items: z.array(residenceImageObject), count: z.number().optional() }),
})

export default residenceImageListDefinition
